<!-- Sem faixa propria: o estado e os botoes vivem na barra de acoes do
     dashboard, que le este componente pelo timerRef. Aqui fica so o modal. -->

<!-- Modal de pausa -->
<div *ngIf="showPauseModal"
     class="fixed inset-0 z-[200] flex items-center justify-center"
     style="background: rgba(16,24,32,.72); backdrop-filter: blur(6px)">
  <div role="dialog" aria-modal="true" aria-labelledby="tituloPausa"
       class="bg-white dark:bg-[#10283A] flex flex-col w-[92vw]"
       style="max-width: 600px; max-height: 88vh; border-radius: 18px; box-shadow: 0 24px 60px -20px rgba(16,24,32,.5)"
       (click)="$event.stopPropagation()">

    <div class="px-7 pt-6 pb-4">
      <p class="uppercase" style="font-size: 9px; font-weight: 800; letter-spacing: .12em; color: var(--brand-primary)">
        Pausar atendimento
      </p>
      <h3 id="tituloPausa" class="dark:text-white" style="font-size: 18px; font-weight: 700; margin-top: 2px">
        Motivo da pausa
      </h3>
      <p style="font-size: 12px; color: var(--tx-2); margin-top: 4px">
        Fica registrado no ciclo de atendimento e define quais ações seguem liberadas.
      </p>
    </div>

    <div role="radiogroup" aria-labelledby="tituloPausa"
         class="motivos-pausa px-7 pb-5 overflow-y-auto">
      <button *ngFor="let r of reasons"
              type="button" role="radio"
              [attr.aria-checked]="selectedReason === r"
              (click)="selectedReason = r"
              class="motivo-pausa flex items-center gap-2 text-left px-3"
              [class.selecionado]="selectedReason === r">
        <span class="radio-motivo shrink-0" [class.marcado]="selectedReason === r"></span>
        <span class="flex-1 py-2 dark:text-gray-200" style="font-size: 14px; line-height: 1.3">{{ r }}</span>
        <span *ngIf="isExpressReason(r)" class="selo-express"
              title="Durante esta pausa você pode gerar Senha Express">Express</span>
      </button>
    </div>

    <div *ngIf="selectedReason === 'Outro'" class="px-7 pt-1 pb-3">
      <input [(ngModel)]="customReason"
             placeholder="Descreva o motivo..."
             class="campo-busca w-full"
             style="height: 40px" />
      <!-- Ambar, nunca vermelho: minimo nao atingido e estado incompleto, nao erro -->
      <span style="font-size: 11px; color: #8A6B12">
        {{ customReason.trim().length }}/{{ outroMinChars }} caracteres mínimos
      </span>
    </div>

    <div class="flex items-center gap-3 px-7 py-4 mt-auto"
         style="border-top: 1px solid #EFE9DD; background-color: var(--flua-rodape); border-radius: 0 0 18px 18px">
      <span style="font-size: 13px; color: var(--tx-2)">
        {{ selectedReason ? selectedReason : 'Nenhum motivo selecionado' }}
      </span>
      <div class="ml-auto flex items-center gap-2">
        <button type="button" (click)="closePauseModal()"
                class="px-6 bg-white dark:bg-transparent"
                style="height: 44px; border-radius: 10px; border: 1px solid var(--flua-borda); font-size: 14px; font-weight: 600; color: var(--tx-2)">
          Cancelar
        </button>
        <button type="button" (click)="confirmPause()"
                [disabled]="!selectedReason || (selectedReason === 'Outro' && customReason.trim().length < outroMinChars)"
                class="px-7 text-white"
                style="height: 44px; border-radius: 10px; font-size: 14px; font-weight: 700"
                [style.background-color]="(!selectedReason || (selectedReason === 'Outro' && customReason.trim().length < outroMinChars)) ? '#E5DFD4' : 'var(--brand-primary)'"
                [style.color]="(!selectedReason || (selectedReason === 'Outro' && customReason.trim().length < outroMinChars)) ? '#8796A1' : '#fff'"
                [style.cursor]="(!selectedReason || (selectedReason === 'Outro' && customReason.trim().length < outroMinChars)) ? 'not-allowed' : 'pointer'">
          Pausar
        </button>
      </div>
    </div>
  </div>
</div>
